<template>
  <AppHeader>All Pending Bottle Summary</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="p-3 bg-white shadow-md rounded-2xl">
      <div class="px-2 py-1 border-2 rounded-xl border-slate-100">
        <p class="text-lg text-gray-600">Owner Type</p>
        <select class="w-full mt-2 bg-transparent outline-none" v-model="owner_type">
          <option value="">-- Select Owner Type --</option>
          <option value="customer">Customer</option>
          <option value="lead">Lead</option>
        </select>
      </div>
    </div>

    <div v-if="owners.length" class="mt-4 responsive-table">
      <table>
        <thead>
          <tr>
            <th>Area Name</th>
            <th>Owners</th>
            <th v-for="product in products" :key="product.id">{{ product.name  }} ({{ product.quantity }})</th>
            <th>Total Bottles</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="owner in owners" :key="owner.id">
            <td>{{ owner.area_name }}</td>
            <td class="capitalize">{{ owner.name }} <small>(#{{ owner.id }})</small></td>
            <td v-for="(product, id) in products" :key="id">
              {{ (owner.product_count.find(p => p.id === product.id) || { count: 0 }).count }}
            </td>
            <td>{{ owner.pending_count }}</td>
            <td class="flex gap-2 justify-center">
              <button @click="initiateCall(owner.phone)" class="px-1 text-gray-800" title="Call Customer"><i class="ion-md-call text-xl"></i></button>
              <button @click="initiateMessage(owner_type, owner.id, 'sms', 'empty_bottle_reminder' )" class="px-1 text-gray-800" title="Send SMS"  :disabled="!owner_type"><i class="ion-md-mail text-xl"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="mt-5 text-center text-gray-500">No data found</div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';

export default {
  name: 'ReportPendingBottleReturnAllSummary',
  mixins: [ mixin ],
  components: { AppHeader, Loading},

  data() {
    return {
      state: 'idle',
      owners: [],
      products: [],
      owner_type: '',
    }
  },

  watch: {
    owner_type(newType) {
      this.getData();
    },
  },

  methods: {
    getData() {
      if (!this.owner_type) {
        this.owners = [];
        this.products = [];
        return;
      }

      this.state = 'loading';

      this.request('GET', 'reports/pending-bottle-return-all-summary?owner_type=' + this.owner_type, null, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.owners = resp.data.owners;
          this.products = resp.data.products;
        } else {
          alert(resp.message);
        }
      });
    },
  },
}
</script>
